import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReTakePhotoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.76017 22H17.2402C20.0002 22 21.1002 20.31 21.2302 18.25L21.7502 9.99C21.8902 7.83 20.1702 6 18.0002 6C17.3902 6 16.8302 5.65 16.5502 5.11L15.8302 3.66C15.3702 2.75 14.1702 2 13.1502 2L10.8602 2C9.83017 2 8.63017 2.75 8.17017 3.66L7.45017 5.11C7.17017 5.65 6.61017 6 6.00017 6C3.83017 6 2.11017 7.83 2.25017 9.99L2.77017 18.25C2.89017 20.31 4.00017 22 6.76017 22Z",
		stroke: "#787878",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.3385 14.0013C15.3385 15.8413 13.8452 17.3346 12.0052 17.3346C10.1652 17.3346 9.04187 15.4813 9.04187 15.4813M9.04187 15.4813H10.5485M9.04187 15.4813V17.148M8.67188 14.0013C8.67188 12.1613 10.1519 10.668 12.0052 10.668C14.2285 10.668 15.3385 12.5213 15.3385 12.5213M15.3385 12.5213V10.8546M15.3385 12.5213H13.8585",
		stroke: "#787878",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgReTakePhotoIcon;
